<div class="domain-promo" [class.domain-promo--free]="isFree" [class.domain-promo--paid]="!isFree">
  <div class="domain-promo__info">
    <div class="domain-promo__icon">
      <umkt-icon [icon]="icon" size="sm"></umkt-icon>
    </div>

    <div class="domain-promo__content">
      <span class="domain-promo__title">{{ domainName }}</span>

      <div class="domain-promo__meta">
        <span class="domain-promo__subtitle">{{ 'components.domainPromo.registrationOneYear' | i18n }}</span>

        <span *ngIf="isFree" class="domain-promo__badge">
          {{ 'components.domainPromo.free' | i18n }}
        </span>
      </div>
    </div>
  </div>

  <span *ngIf="isFree; else paidPrice" class="domain-promo__price">
    {{ 'components.domainPromo.free' | i18n }}
  </span>

  <ng-template #paidPrice>
    <span *ngIf="priceText; else numericPrice" class="domain-promo__price">{{ priceText }}</span>

    <ng-template #numericPrice>
      <span *ngIf="price !== null" class="domain-promo__price">{{ price | currencyBRL }}</span>
    </ng-template>
  </ng-template>
</div>
